import { Button } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';

export default function CustomizePackageCard() {
  const { t } = useTranslation('app');

  return (
    <div className="packages-special-card">
      <div className="flex  flex-col gap-2x h-auto md:h-[163px]">
        <p className="text-title-4 text-black">{t('customizePackageTitle')}</p>
        <p className="text-body-2 text-gray__dark_2">
          {t('customizePackageDescription')}
        </p>
      </div>
      <div className="flex flex-col gap-1.5x">
        <Button
          variant="secondary"
          size="medium"
          className="rounded-[26px]"
          onClick={() => {
            window.location.href = `${process.env.REACT_APP_BASE_URL}/i/joinus/index-en.html`;
          }}
        >
          {t('contactUs')}
        </Button>
        <span className="text-caption-2 text-gray__dark_1 text-center">
          {t('customizePackageFooter')}
        </span>
      </div>
    </div>
  );
}
